export enum ECitySelect {
    OPEN_CITYSELECT = '@CITYSELECT/OPEN',
    SET_REGIONS = '@CITYSELECT/SET_REGIONS',
    SET_TOP_CITIES = '@CITYSELECT/SET_TOP_CITIES',
    SET_SATELLITES = '@CITYSELECT/SET_SATELLITES',
    SET_SELECTED_REGION = '@CITYSELECT/SET_SELECTED_REGION',
    CLOSE_CITYSELECT = '@CITYSELECT/CLOSE',
}

export type { TCloseCitySelect } from './closeCitySelect';
export { default as closeCitySelect } from './closeCitySelect';
export type { TOpenCitySelect } from './openCitySelect';
export { default as openCitySelect } from './openCitySelect';
export type { TSetRegions } from './setRegions';
export { default as setRegions } from './setRegions';
export type { TSetSatellites } from './setSatellites';
export { default as setSatellites } from './setSatellites';
export type { TSetSelectedRegion } from './setSelectedRegion';
export { default as setSelectedRegion } from './setSelectedRegion';
export type { TSetTopCities } from './setTopCities';
export { default as setTopCities } from './setTopCities';
